import { Routes } from '@angular/router';
import { AppLayoutComponent } from './shared/ui/app-layout/app-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { environment } from '../environments/environment';

export const routes: Routes = [
  // La raíz redirige explícitamente: sin esto el router entra en el grupo de auth
  // (también path:''), no encuentra hijo para '' y la navegación muere en blanco
  // sin probar el grupo del layout ni el wildcard.
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  // Auth pages render outside the Shell (no header/sidebar) and are anonymous by definition.
  {
    path: 'quote-review',
    loadComponent: () =>
      import('./features/public-quote-review/public-quote-review/public-quote-review.component').then(
        (m) => m.PublicQuoteReviewComponent,
      ),
  },
  {
    path: '',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./features/account/account.routes').then((m) => m.accountRoutes),
      },
      {
        path: 'admin',
        loadChildren: () => import('./features/admin/admin.routes').then((m) => m.adminRoutes),
      },
      {
        path: 'leads',
        loadChildren: () => import('./features/leads/leads.routes').then((m) => m.leadsRoutes),
      },
      {
        path: 'clients',
        loadChildren: () =>
          import('./features/clients/clients.routes').then((m) => m.clientsRoutes),
      },
      ...(!environment.production
        ? [
            {
              path: 'ui',
              loadChildren: () =>
                import('./features/ui-kit/ui-kit.routes').then((m) => m.uiKitRoutes),
            },
          ]
        : []),
      {
        path: 'quotes',
        loadChildren: () => import('./features/quotes/quotes.routes').then((m) => m.quotesRoutes),
      },
      {
        path: 'invoices',
        loadChildren: () =>
          import('./features/invoices/invoices.routes').then((m) => m.invoicesRoutes),
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./features/payments/payments.routes').then((m) => m.paymentsRoutes),
      },
      {
        path: 'expenses',
        loadChildren: () =>
          import('./features/expenses/expenses.routes').then((m) => m.expensesRoutes),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
